import React, { Component } from 'react'
import { withRouter } from 'react-router'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import SocialUserEmailPageUI from './SocialUserEmailPageUI.js'

class SocialUserEmailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    let params = new URLSearchParams(window.location.search)
    let provider = params.get('provider')
    if (!['Facebook', 'Google'].includes(provider))
      provider = 'Unknown'

    return (
      <SocialUserEmailPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        provider={provider}
        onReRequest={this.onReRequest}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onReRequest = (event) => {
    event.preventDefault()
    let params = new URLSearchParams(window.location.search)
    window.location = params.get('reRequestUrl')
  }

  getMessages(context) {
    let arr = [
      'c_email_required',
      'c_fb_email_req_ms',
      'c_provide_email',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_email_req', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default withRouter(SocialUserEmailPageSF)
